// extracted by mini-css-extract-plugin
export var displayNone = "_qo-6";
export var imgContainer = "_qo-2";
export var overflowHidden = "_qo-3";
export var productInfoCardButtonContainer = "_qo-5";
export var productTitleText = "_qo-4";
export var rightArrow = "_qo-1";
export var rightArrowContainer = "_qo-0";